(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/ball/assets/javascripts/ball-lotto.js') >= 0) return;  svs.modules.push('/components/tur/ball/assets/javascripts/ball-lotto.js');
'use strict';

svs.tur = svs.tur || {};
svs.tur.ball = svs.tur.ball || {};
class BallLotto extends svs.tur.ball.Default {
  constructor(options) {
    options.productId = 'Lotto';
    super(options);
    this.log = new svs.core.log.Logger('ball.lotto');
  }
  classNames() {
    const classNames = ['ball-lotto'];
    if (this.extraNumber) {
      classNames.push('ball-extra-number');
    }
    return classNames;
  }
}
svs.tur.ball.Lotto = BallLotto;

 })(window);